/* istanbul ignore file */
export * from './CollapsibleCard';
